import { Button } from '@authentic/loyalty-pwa/components';
import { Typography, Box, getImageSrc } from '@authentic/loyalty-pwa/util';
import { breakpoints } from '@authentic/loyalty-pwa/util/variables';
import { Fragment, FunctionalComponent, h } from 'preact';
import styled from 'styled-components';
import { link } from '@authentic/loyalty-pwa/util';
import { SignUpContainer } from '../containers/SignUpContainer';
import { useContext, useEffect, useState } from 'preact/hooks';
import { UserServiceContext } from '@authentic/loyalty-pwa/providers';
import { UserAccountConfirmationResult } from '@authentic/loyalty-pwa/interfaces';

const FormControlStyled = styled.div`
  margin-bottom: 32px;
`;

const Link = styled.a`
  text-decoration: none;
  display: block;
  button {
    cursor: pointer;
  }
`;

const Wrapper = styled(SignUpContainer)`
  background-image: url(${getImageSrc(require('../assets/churro-sm.png').default)});
  background-repeat: no-repeat;
  background-position: bottom center;
  padding-bottom: 56px;

  @media screen and (min-width: ${breakpoints.sm}) {
    background-image: none;

    .white-box {
      background-image: url(${getImageSrc(require('../assets/churro-xl.png').default)});
      background-repeat: no-repeat;
      background-position: bottom center;
      padding-bottom: 100px;
    }
  }
`;

export const SignInButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  a {
    width: 100%;
    
  }
  button {
    cursor: pointer;
  }
  a:nth-child(1) {
    margin-right: 6px;
  }
  @media screen and (max-width: ${breakpoints.sm} ) {
    display: block;
  }
`;

export const EmailVerified: FunctionalComponent = (props) => {
  const [isValidConfirmationToken, setIsValidConfirmationToken] = useState(true);
  const userService = useContext(UserServiceContext);

  useEffect(() => {
    const queryParams: any = props;
    if (queryParams.confirmation_token) {
      userService
        ?.confirmationToken({ confirmationToken: queryParams.confirmation_token })
        .then((res: UserAccountConfirmationResult) => {
          if (res.success) {
            setIsValidConfirmationToken(true);
          } else {
            if (res.code === 6002 && res.name == 'already_confirmed') {
              setIsValidConfirmationToken(true);
            } else {
              setIsValidConfirmationToken(false);
            }
          }
        })
    } else {
      setIsValidConfirmationToken(false);
    }
  });

  return (
    <Fragment>
      {(isValidConfirmationToken && (
        <Wrapper
          pageTitle='Email Verified'
          title={
            <Fragment>
              EMAIL VERIFIED
            </Fragment>
          }
          topHint=""
        >
          <Box mb={16}>
            <Typography variant="body1">
              Thanks! Now you're ready to start earning.
            </Typography>
          </Box>
          <div>
            <FormControlStyled>
              <SignInButtons>
                <a href="https://dl.em.deltaco.com/?dl=sign_in">
                  <Button ariaLabel="Log into the Mobile App" fullWidth>
                    Log into the Mobile App
                  </Button>
                </a>
                <Link href={link('/sign-in')}>
                  <Button ariaLabel="Log into the Web App" fullWidth>
                    Log into the Web App
                  </Button>
                </Link>
              </SignInButtons>
            </FormControlStyled>
          </div>
        </Wrapper>
      ))}

      {(!isValidConfirmationToken && (
        <Wrapper
          pageTitle='Verification Failed!'
          title={
            <Fragment>
              Verification Failed!
            </Fragment>
          }
          topHint=""
        >
          <Box mb={16}>
            <Typography variant="body1">
              Invalid Confirmation Token. Please go to your email and click the link again.
            </Typography>
          </Box>
          <div>
            <FormControlStyled>
              <SignInButtons>
                <a href="https://dl.em.deltaco.com/?dl=sign_in">
                  <Button ariaLabel="Log into the Mobile App" fullWidth>
                    Log into the Mobile App
                  </Button>
                </a>
                <Link href={link('/sign-in')}>
                  <Button ariaLabel="Log into the Web App" fullWidth>
                    Log into the Web App
                  </Button>
                </Link>
              </SignInButtons>
            </FormControlStyled>
          </div>
        </Wrapper>
      ))}
    </Fragment>
  );
};
